<div [matMenuTriggerFor]="menu">
  <ng-content></ng-content>
</div>
<mat-menu #menu="matMenu">
  @for (menuItem of menuItems; track menuItem?.transId) {
    <button mat-menu-item [routerLink]="menuItem.route" (click)="openHelp(menuItem)">
      <mat-icon>{{menuItem.icon}}</mat-icon>
      <span>{{menuItem.text}}</span>
    </button>
  }
</mat-menu>
